import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(isBetween);
import { fetchHorariosCallMeNow  } from 'src/bff/api';

/**
 * Comprueva el día a de la semana que es y descarta aquellos que devuelven array vacía o strings vacías.
 * @returns
 */
const dayOfTheWeek = (horarios: any, info: any) => {
  const today = dayjs(info.timestamp).format('dddd').toLowerCase();
  if(horarios[today].length === 0 ) {
    return false;
  } else {
    return isBetweenNormalDayHours(info.timestamp, horarios[today]);
  }
};

/**
 * Si está entre las 9 y las 19 devuelve true
 * @returns
 */
const isBetweenNormalDayHours = (date: string, horas: any) => {
  const now = dayjs(date);
  let isOpen;

  const auxFrom = horas[0].from.split(':');
  const auxTo = horas[0].to. split(':');

  const todayStart = dayjs().hour(auxFrom[0]).minute(auxFrom[1]).second(0);
  const todayFinish = dayjs().hour(auxTo[0]).minute(auxTo[1]).second(0);
  
  isOpen = dayjs(now).isBetween(todayStart, todayFinish);

  return isOpen;
};

/**
 * Comprueba que sea uno de los días festivos.
 * @returns
 */
const isHoliday = (closedDays: any) => {
  const today = dayjs();
  const hideDay = closedDays.some((date:any) => {
    const dateToCompare = dayjs()
      .date(date.day)
      .month(date.month - 1); // Los meses van de 0 a 11
    return dayjs(today).isSame(dateToCompare, 'day');
  });
  return hideDay;
};

/**
 * Comprueba que sea uno de los dias que solo abren hasta mediodía.
 * @returns
 */
const isOpenJustMidDay = (partialDays: any) => {
  const today = dayjs();

  const hideDay = partialDays.some((date: any) => {
    const dateToCompare = dayjs()
      .date(date.day)
      .month(date.month - 1); // Los meses van de 0 a 11

    return dayjs(today).isSame(dateToCompare, 'day');
  });

  return hideDay;
};

/**
 * En caso de que solo se abra hasta mediodía se comprueba si está en las horas en las que está abierto el call center.
 * @returns
 */

const isBetweenMidDayHours = (partialDays: Array<any>) => {
  const now = dayjs();
  const dayMonth = dayjs().format('DD/MM');
  const manipulatedNow = dayMonth.split('/');
  const today = partialDays.find((d) =>{ return d.day === manipulatedNow[0] && d.month === manipulatedNow[1];});
  let isOpen;

  const auxFrom = today.open[0].from.split(':');
  const auxTo = today.open[0].to.split(':');

  const todayStart = dayjs().hour(auxFrom[0]).minute(auxFrom[1]).second(0);
  const todayFinish = dayjs().hour(auxTo[0]).minute(auxTo[1]).second(0);
  
  isOpen = dayjs(now).isBetween(todayStart, todayFinish);

  return isOpen;
};

/**
 * Solo aplica a comerciales. En caso de turismos siempre devolvemos true ya que no tenemos que ocultar el cta.
 * @returns
 */

export const isCallCenterOpen = async () => {
  return await fetchHorariosCallMeNow()
    .then((resp) => {
      return checkIfIsCallCenterOpen(resp);
    });
};

const checkIfIsCallCenterOpen = (resp: any) => {

  if(resp?.horarios.closed === 1) {
    return false;
  }

  if (isHoliday(resp.horarios.exceptions.closed)) {
    return false;
  } else if (isOpenJustMidDay(resp.horarios.exceptions.partial)) {
    return  isBetweenMidDayHours(resp.horarios.exceptions.partial);
  } else {
    return dayOfTheWeek(resp.horarios, resp.info);
  }
  
};
